module.exports = __webpack_public_path__ + "static/media/Follow_Along.4bcd01e7.png";